import React from 'react'
import {
    StyledOverviewButton,
    adUnitListClassName,
    StyledDebugAdUnitListContainer,
} from './DebugAdUnitsList.styled'
import { AdState } from 'common/advertising/ad-state'
import { AdsByBreakpoint } from './DebugAdsByBreakpoint'
import { IsHydrating } from 'common/context-providers/is-hydrating'

interface Props {
    pathname: string
    ads: AdState | undefined
}

const scrollToOverview = () => {
    const item = document.getElementsByClassName(adUnitListClassName)
    if (item) {
        item[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
}

export const DebugAdUnitsList: React.FC<Props> = ({ pathname, ads }) => {
    const pageAds = `page: ${pathname} ads`
    const isHydrating = React.useContext(IsHydrating)

    if (!ads || isHydrating) {
        return null
    }

    return (
        <StyledDebugAdUnitListContainer>
            <StyledOverviewButton onClick={() => scrollToOverview()}>
                Ads Overview
            </StyledOverviewButton>
            <AdsByBreakpoint ads={ads} pageAds={pageAds} />
        </StyledDebugAdUnitListContainer>
    )
}
DebugAdUnitsList.displayName = 'DebugAdUnitsList'
